import { Trans } from '@lingui/react/macro'

import type { FC } from 'react'
import type { ICmsCta } from '@/pages/tad.ai/_components/FeatureCms/_types'

import { PrimaryButton } from '@/pages/tad.ai/_components/PrimaryButton'
import { H2 } from '@/pages/tad.ai/_components/H2'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface ICtaProps {
  cta?: ICmsCta | null
  className?: string
}

export const Cta: FC<ICtaProps> = (props) => {
  const { cta, className } = props
  if (!cta) {
    return null
  }
  const { title, desc, btnText, btnHref } = cta

  return (
    <div
      className={cls`relative z-[1] flex flex-col items-center ${className}`}
    >
      <span
        style={{
          background:
            'linear-gradient(360deg, rgba(201, 175, 255, 0.2) 0%, rgba(121, 105, 153, 0.2) 100%)',
        }}
        className='text-f-other-9 mx-auto block w-fit rounded-full border border-[#C9AFFF33] px-5 py-1.5 text-xs md:text-sm'
      >
        <Trans>Tad.ai</Trans>
      </span>
      <H2 className='md:text-7xl'>{title}</H2>
      <RichTextElement
        as='p'
        html={desc}
        className='text-f-other-10 pt-2 text-center text-sm md:pt-6 md:text-xl'
      />
      {btnText && btnHref && (
        <PrimaryButton href={btnHref} className='mt-6 md:mt-12'>
          {btnText}
        </PrimaryButton>
      )}
    </div>
  )
}
